﻿import React from 'react';
import { OfferProgress } from '../../apiTypes/PromoApi/PromoOffer';
import BlurGradientBackground from '../BlurGradientBackground/BlurGradientBackground';

type OfferProgressProps = {
  expiryTimeCountDown?: string;
  applicableProducts?: string[];
  remainingDays?: number;
  serviceSubType?: string
} & OfferProgress;

export default (props: OfferProgressProps) => {
  const { currentVal, targetVal, remainingDays, type, applicableProducts, serviceSubType } = props;
  const targetValue = Number(targetVal);
  // When Bingo, currentValue is the number of remaining bingo cards - but we want to display the amount used.
  const currentValue = applicableProducts?.includes('bingo') ? targetValue - Number(currentVal) : Number(currentVal);

  const getPrettyName = () => {
    if (type === 'FREE_SPIN') return 'Freespins';
    if (type === 'WAGER') return 'Indbetalingsbonus';
    if (applicableProducts?.includes('bingo')) return 'Gratis bingoplader';
    return type;
  };

  const showAsPercentage = () => (serviceSubType === 'FIXED_DEPOSIT_WAGER' || serviceSubType === 'FIXED_NODEPOSIT_WAGER') && currentValue === 0 && targetValue === 0;

  const getProgressStatus = () => {
    if (showAsPercentage()) {
      return `${targetValue / currentValue || 0}%`;
    } else if (serviceSubType === 'FIXED_DEPOSIT_WAGER' || serviceSubType === 'FIXED_NODEPOSIT_WAGER') {
      return `${currentValue / 100} kr. / ${targetValue / 100} kr.`;
    } else {
      return `${currentValue} / ${targetValue}`;
    }
  };

  return <div className={'absolute left-0 right-0 bottom-0 bg-primary-gradient p-16 '}>
    <div className={'relative z-10 text-white'}>

      <div className={'flex justify-between items-center mb-2'}>
        <div className={'text-14 font-bold'}>{getPrettyName()}</div>
        <div className={'text-12'}>{remainingDays && <span>Udløber om {remainingDays} dag{remainingDays === 1 ? '' : 'e'}</span>}</div>
      </div>
      <div className={'flex items-center gap-10'}>
        <div className={'font-bold text-10 lining-nums w-fit shrink-0'}>
          {getProgressStatus()}
        </div>
        <div className={'relative overflow-hidden w-full h-6 rounded-full bg-white/30 after:bg-white after:absolute after:h-full after:left-0 after:w-(--progress)'} style={{
          '--progress': `${(currentValue / Number(targetVal) * 100)}%`
        } as React.CSSProperties} />
      </div>
    </div>
    <BlurGradientBackground/>
  </div>;
};
